/* RESPONSIBLE TEAM: team-reporting */

import type { AxisLabelsFormatterContextObject } from 'highcharts';
import { formatSeconds } from '@/features/report-snapshots/formatters/duration';
import { fromFloatToPercentageString } from '@/features/report-snapshots/formatters/percentage';
import { ChartSchema } from '@/features/report-snapshots/api/schema';
import { i18n } from '@lingui/core';
import { translateCellName } from '@/features/report-snapshots/utils/chart-data-helpers';

interface LegendLabelFormatterContextObject {
  name: string;
}

export function formatLegendLabels(this: LegendLabelFormatterContextObject) {
  return translateCellName(this.name, i18n);
}

export function formatHeatmapLegendLabels(chartSchema: ChartSchema) {
  return function (this: AxisLabelsFormatterContextObject) {
    const unit = chartSchema.columnDefinitions[1].unit;

    switch (unit) {
      case 'seconds':
        return formatSeconds(this.value as number);
      case 'percent':
        return fromFloatToPercentageString(this.value as number);
      default:
        return this.value as string;
    }
  };
}
